<ng-template #customerDetailsRef let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Customer Details</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<i class="fa fa-close"></i>
		</button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="col-12">
				<div class="table-responsive">
					<table class="table table-fixed table-striped table-hover w-100" *ngIf="customerdetails?.length">
						<thead class="thead-dark sticky-header">
							<tr>
								<th>Date</th>
								<th>Item</th>
								<th>Desc</th>
								<th>Qty</th>
								<th>Price</th>
								<th>Total</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let i of customerdetails">
								<td>{{ i.date_added }}</td>
								<td>{{ i.stockid }}</td>
								<td>{{ i.name }}</td>
								<td>{{ i.quantity }}</td>
								<td>{{ i.price | currency }}</td>
								<td>{{ i.price * i.quantity | currency }}</td>
							</tr>
						</tbody>
					</table>
					<h4 class="text-center mt-3" *ngIf="!customerdetails?.length">No Records Found</h4>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer"></div>
</ng-template>

<div class="container-fluid tp-box" [@flipState]="flip">
	<!-- FRONT VIEW -->
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="card card-stats">
			<div class="card-header card-header-info card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(topcustomers, title)">
					<i class="material-icons">stars</i>
				</div>
				<p class="card-category">{{ title }}</p>

				<h3 class="card-title mt-2 mb-0">
					<span *ngIf="loading">
						<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</span>
					<span *ngIf="!loading">
						{{ topcustomers.length }}
					</span>
					<br /><br />
				</h3>
			</div>

			<div class="card-footer">

				<div class="stats pointer">
					<a (click)="toggleFlip(topcustomers, title)">
						<i class="material-icons">visibility</i> View Now
					</a>

				</div>
			</div>
		</div>
	</div>

	<!-- BACK VIEW -->
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="card">
			<div class="card-header card-header-info card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(false, '')">
					<i class="material-icons">login</i>
				</div>

				<div class="d-flex justify-content-between align-items-center w-100">
					<h3 class="card-title mb-0">Top {{ limit }} Customers</h3>
					<form [formGroup]="searchForm">
					<label class="form-label fw-bold">Transaction Dates</label>
					<mat-form-field appearance="outline" class="w-100">
						<mat-date-range-input [rangePicker]="picker">
							<input matStartDate formControlName="fromDateCtrl" placeholder="Start Date" />
							<input matEndDate formControlName="toDateCtrl" placeholder="End Date" />
						</mat-date-range-input>
						<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
						<mat-date-range-picker #picker></mat-date-range-picker>
					</mat-form-field>
					</form>
					<div class="d-flex align-items-center gap-2 ms-auto">
						<label for="limitInput" class="mb-0">Limit:</label>
						<input id="limitInput" type="number" min="1" max="500" [(ngModel)]="limit" (change)="reloadCustomers()" class="form-control form-control-sm" style="width: 80px;" />

						<button class="btn btn-sm btn-outline-light" [disabled]="loading" (click)="reloadCustomers()">
							<ng-container *ngIf="!loading">
								<i class="material-icons">refresh</i>
							</ng-container>
							<ng-container *ngIf="loading">
								<svg class="spinner" width="20px" height="20px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
									<circle class="path" fill="none" stroke-width="5" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
								</svg>
							</ng-container>
						</button>
					</div>
				</div>
			</div>



			<div class="card-body" *ngIf="viewing">

				&nbsp;&nbsp; <button class="btn btn-success btn-sm" (click)="$event.preventDefault();exportXls()" *ngIf="!sending">
					<i class="fa fa-file-excel-o"></i> XLS
				</button>
				&nbsp;&nbsp;
				<button class="btn btn-danger btn-sm" (click)="$event.preventDefault();exportPdf()" *ngIf="!sending">
					<i class="fa fa-file-pdf-o"></i> PDF
				</button>
				&nbsp;&nbsp;

				<div class="table-responsive">
					<table class="table table-fixed table-sm table-fixed">
						<thead class="thead-dark sticky-header">
							<tr>
								<th class="sticky-header">Customer #</th>
								<th class="sticky-header">Name</th>
								<th class="sticky-header">Last Seen</th>
								<th class="sticky-header">Sales Total</th>
								<th class="sticky-header">Units</th>

							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let d of viewing">
								<td> <a [routerLink]="['/customers/view/', d.debtorno]" class="text-decoration-none">
									  {{ d.debtorno }}.{{ d.branchcode }}
									</a></td>
								<td>{{ d.name || d.deliverto }}</td>
								<td>{{ d.lastseen }}</td>

								<td>{{ d.salestotal | currency }}</td>
								<td>{{ d.qtytotal | number }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>


</div>